module.exports = __webpack_public_path__ + "static/media/colanInfotechLogo.0c169fce.png";